import DonadorasExternasOverview from '../../features/donadoras-externas/layouts/overview';

// TSS vite/01 — thin page. Monta la feature de propuestas de donadoras
// externas (staging con curaduría). La edición/retiro es modal, no ruta.
// Guarded por <AuthRoute> (shell) + gateada a `donor_owner` en el nav.

export default function DonadorasExternasPage() {
    return <DonadorasExternasOverview />;
}
